import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../../../../../../components/FeaturedTable/FeaturedTable'
import { customTasksColumns } from '../../helpers'

const CustomTasksTable = ({
  data,
  selectedBuilding,
  userRole,
  onEdit = () => {},
  onDuplicate = () => {},
  onDelete = () => {},
}) => {
  const { t } = useTranslation(['checklists-settings'])
  return (
    <div className="ctp-checklists-wrapper-main-table">
      {selectedBuilding && selectedBuilding.timezone && data.length ? (
        <FeaturedTable
          columns={customTasksColumns({ onEdit, onDuplicate, onDelete, userRole, t })}
          data={data}
          onRowClick={(row) => onEdit(row.original)}
        />
      ) : (
        <div className="no-data">{t('checklists-settings:manageInspection.noDataMessage')}</div>
      )}
    </div>
  )
}

CustomTasksTable.propTypes = {
  data: PropTypes.array,
  selectedBuilding: PropTypes.object,
  userRole: PropTypes.string,
  onEdit: PropTypes.func,
  onDuplicate: PropTypes.func,
  onDelete: PropTypes.func,
}

export default CustomTasksTable
